/**
 * Lead form helpers: pre-select the service from ?service=, block past dates,
 * show a sending state, and move focus to the success or error notice after a submit.
 */

function today() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

/** @param {HTMLFormElement} form */
function enhance(form) {
  if (form.dataset.acEnhanced) return;
  form.dataset.acEnhanced = 'true';

  const service = new URLSearchParams(window.location.search).get('service');
  const select = form.querySelector('select[data-ac-service-select]');
  if (service && select instanceof HTMLSelectElement && !select.value) {
    const match = [...select.options].find((option) => option.dataset.service === service);
    if (match) match.selected = true;
  }

  for (const input of form.querySelectorAll('input[data-ac-min-today]')) {
    if (input instanceof HTMLInputElement) input.min = today();
  }

  for (const field of form.querySelectorAll('input, select, textarea')) {
    field.addEventListener('blur', () => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
      if (field.value || field.hasAttribute('aria-invalid')) {
        field.setAttribute('aria-invalid', String(!field.checkValidity()));
      }
    });
  }

  // Shopify's spam check can pause the submit for a challenge, so the button is never disabled
  // and the busy label resets on its own if the page hasn't moved on.
  form.addEventListener('submit', () => {
    const button = form.querySelector('button[type="submit"]');
    if (!(button instanceof HTMLButtonElement) || button.hasAttribute('aria-busy')) return;
    const label = button.textContent ?? '';
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.sendingLabel ?? label;
    window.setTimeout(() => {
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }, 6000);
  });

  // The notice is rendered after the redirect back from a submit.
  const notice = form.querySelector('[data-ac-form-notice]');
  if (notice instanceof HTMLElement) {
    requestAnimationFrame(() => {
      notice.scrollIntoView({ block: 'center' });
      notice.focus({ preventScroll: true });
    });
  }
}

function init() {
  for (const form of document.querySelectorAll('form[data-ac-form]')) {
    if (form instanceof HTMLFormElement) enhance(form);
  }
}

init();
document.addEventListener('shopify:section:load', init);
